<template>
  <div class="d-flex align-items-center p-2">
    <a-avatar
      alt="avatar"
      :style="{ color: ' #ffffff !important', 'background-color': user.user_details.url ? '' : getAvatarColor(user.user_details.id) }"
      :size="40"
      class="comment-avatar"
      :src="user.user_details.url"
    >
      {{ user.user_details.display_name ? user.user_details.display_name[0].toUpperCase() : "D" }}
    </a-avatar>
    <div class="align-items-start ml-3 d-flex flex-column">
      <p class="m-0 gray800 font16 fw700 text-capitalize">
        {{ user.user_details.display_name }}
      </p>
      <div class="d-flex align-items-center font12 fw700 gap4 rounded px-2 py-1 text-capitalize" :style="{ color: getColor(), backgroundColor: getBGColor() }">
        <font-awesome-icon :icon="['fal', 'user-md']" v-if="user.user_details.role === 'doctor' || user.user_details.role === 'physician'" />
        <font-awesome-icon :icon="['fal', 'user-nurse']" v-if="user.user_details.role === 'ohcp' || user.user_details.role === 'hcp'" />
        <font-awesome-icon :icon="['fal', 'hospital-alt']" v-if="user.user_details.role === 'hospital_administrator'" />
        <font-awesome-icon :icon="['fal', 'hospital']" v-if="user.user_details.role === 'clinic_administrator'" />
        <font-awesome-icon :icon="['far', 'hand-holding-heart']" v-if="user.user_details.role === 'nfp_administrator'" />
        <font-awesome-icon :icon="['far', 'store']" v-if="user.user_details.role === 'business_administrator'" />
        <font-awesome-icon :icon="['far', 'hands-heart']" v-if="user.user_details.role === 'caregiver'" />
        <font-awesome-icon :icon="['fas', 'bullhorn']" v-if="user.user_details.role === 'advocate'" />
        {{ getRoleName(user.user_details.role) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NameCard",
  props: { user: Object },
  methods: {
    getBGColor() {
      switch (this.user.user_details.role) {
        case "app":
        case "hcp":
        case "ahcp":
        case "ohcp":
        case "other":
        case "physician":
        case "doctor":
        case "nfp":
        case "nfp_administrator":
        case "clinic":
        case "clinic_administrator":
        case "hospital":
        case "hospital_administrator":
        case "business":
        case "business_administrator":
          return "#FFF0D6"

        case "patient":
        case "advocate":
        case "caregiver":
          return this.getPrimary50Color()
      }
    },
    getColor() {
      switch (this.user.user_details.role) {
        case "app":
        case "hcp":
        case "ahcp":
        case "ohcp":
        case "other":
        case "physician":
        case "doctor":
        case "nfp":
        case "nfp_administrator":
        case "clinic":
        case "clinic_administrator":
        case "hospital":
        case "hospital_administrator":
        case "business":
        case "business_administrator":
          return "#F5A623"

        case "patient":
        case "advocate":
        case "caregiver":
          return this.getPrimaryColor()
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/reactions/NameCard.vue